export interface PeriodChange {
  delta: number;
  deltaPercent: number;
}

export const toNumber = (value?: number | string): number => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0;
  }

  if (typeof value === 'string') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  return 0;
};

export const formatInteger = (value: number): string => value.toLocaleString('en-US');

export const buildPeriodChange = (currentTotal: number, previousTotal: number): PeriodChange => {
  const delta = currentTotal - previousTotal;
  const deltaPercent = previousTotal > 0 ? (delta / previousTotal) * 100 : 0;
  return { delta, deltaPercent };
};
